import "../sass/child-styles.scss"

import DynamicSiteLogo from "./modules/./DynamicSiteLogo";
import SectionScrollEffect from "./modules/SectionScrollEffect";
import LightboxModal from "./modules/LightboxModal";

const dynamicSiteLogo = new DynamicSiteLogo();
const sectionScrollEffect = new SectionScrollEffect();
const lightboxModal = new LightboxModal();